// utils
import axios from '../../utils/axios';

const updateOrgApi = async (data, mongoOrgId) => {
  try {
    const response = await axios({
      method: 'put',
      url: `/organizations/${mongoOrgId}`,
      data,
    });
    const res = await response.data;
    return res;
  } catch (error) {
    throw new Error(JSON.stringify(error));
  }
};

export { updateOrgApi };
